module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 51 64",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }